module.exports = __webpack_public_path__ + "public/images/astronaut.d1faf8aadca6fa695bb5604e18eaad16.webp";